import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";

/* Guest Cart Token */
export const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

export const AddToCart = async (prod_id, qty = 1) => {
  const userId = sessionStorage.getItem("userId");
  const cartToken = !userId ? getCartToken() : null;

  return axios.post(
    `${BASE_URL}/index.php/Api/insert_cart`,
    {
      user_id: userId,
      cart_token: cartToken,
      prod_id,
      qty,
    },
    { headers: { "Content-Type": "application/json" } }
  );
};
